<style lang="less">@import "../css/login.less";</style>
<template>
    <div class="loginBox">
        <div class="loginCard">
            <div class="sys-title">{{title}}</div>
            <div class="sys-sub-title-box">
                <el-image class="rightIcon" :src="require('@/assets/login_right.png')"></el-image>
                <div class="sub-title">欢迎登录</div>
            </div>
            <div class="loginBody">
                <el-form ref="loginForm" :model="login" :rules="loginRules" @submit.native.prevent="doLogin" style="width: 100%">
                    <el-form-item prop="username">
                        <el-input v-model="login.username" placeholder="请输入用户名" style="width: 100%;" prefix-icon="el-icon-user"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="login.password" placeholder="请输入密码" style="width: 100%" prefix-icon="el-icon-lock" type="password"></el-input>
                    </el-form-item>
                    <el-form-item prop="yzm">
                        <el-col :span="18">
                            <el-input v-model="login.yzm" placeholder="请输入验证码" style="width: 100%" prefix-icon="el-icon-lock"></el-input>
                        </el-col>
                        <el-col :span="6" style="height: 48px">
                            <el-image class="yzm" :src="baseURL+'/admin/captcha?timestamp='+timestamp" @click="reloadYzm" ref="yzm"></el-image>
                        </el-col>
                    </el-form-item>
                    <el-button type="primary" native-type="submit" class="loginBtn">登 录</el-button>
                </el-form>
                <span class="msg">{{msg}}</span>
            </div>
        </div>
        <div class="login-copyright">毛豆随行 © 2022-2025<br>tesla.touping.vip</div>
    </div>
</template>

<script>
import {login} from '@/api/login'
import config from '@/config';
import md5 from 'js-md5';
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev1 : config.baseUrl.pro+'/api'

export default {
    name: 'login',
    data() {
        return {
            title: config.title,
            imgServer: config.imgServer,
            login: {
                username: '',
                password: '',
                sub_pass: '',
                yzm: ''
            },
            msg: '',
            loginRules: {
                username: [
                    {required: true, message: '用户名不能为空', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'}
                ],
                yzm: [
                    {required: true, message: '验证码不能为空', trigger: 'blur'}
                ],
            },
            width: 0,
            height: 0,
            timestamp: new Date().getTime(),
            baseURL: baseUrl
        }
    },
    mounted(){
        const width = window.innerWidth;
        const height = window.innerHeight;
        this.width = width
        this.height = height
    },
    methods: {
        doLogin(){
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    let temp = md5(this.login.password).toUpperCase()
                    this.login.sub_pass = md5(this.login.username+temp)
                    login(this.login.username, this.login.sub_pass, this.login.yzm).then(res=>{
                        if(res.code == 1){
                            sessionStorage.setItem("U_TOKEN", res.msg)
                            let redirectPath = sessionStorage.getItem("redirectPath")
                            if(this.$isNotNull(redirectPath)){
                                sessionStorage.removeItem("redirectPath")
                                this.$router.push({path: redirectPath})
                            }else{
                                this.$router.push({path: '/home'})
                            }
                        }else{
                            this.msg = res.msg
                        }
                    })
                } else {
                    return false;
                }
            });
            return false
        },
        reloadYzm(){
            // 方式1：使用时间戳作为随机参数（推荐）
            this.timestamp = new Date().getTime();
            
            // 给图片加载完成后移除加载状态
            const imgEl = this.$refs.yzm.$el.querySelector('img');
            if (imgEl) {
                imgEl.onload = () => {};
                imgEl.onerror = () => {this.$message.error('验证码加载失败，请重试');};
            }
        },
    }
}
</script>